import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './DeliveryBlueprint.css';

const DeliveryBlueprint = () => {
  const { t, i18n } = useTranslation();

  const sections = [
    {
      id: 'custom-dev',
      title: t('features.customDev.title'),
      description: t('features.customDev.description'),
      detail: t('features.customDev.detailedText'),
    },
    {
      id: 'ecommerce',
      title: t('features.ecommerce.title'),
      description: t('features.ecommerce.description'),
      detail: t('features.ecommerce.detailedText'),
    },
    {
      id: 'scalable-architecture',
      title: t('features.scalableArchitecture.title'),
      description: t('features.scalableArchitecture.description'),
      detail: t('features.scalableArchitecture.detailedText'),
    },
  ];

  return (
    <div className="blueprint-page" id="top">
      <section className="blueprint-hero">
        <div className="blueprint-ambient ambient-a" aria-hidden="true"></div>
        <div className="blueprint-ambient ambient-b" aria-hidden="true"></div>
        <div className="blueprint-hero__content">
          <p className="blueprint-eyebrow">{t('hero_eyebrow')}</p>
          <h1>{t('blueprint_title')}</h1>
          <p className="blueprint-subtitle">{t('blueprint_subtitle')}</p>
          <p className="blueprint-intro">{t('blueprint_intro')}</p>
          <div className="blueprint-cta-row">
            <NavLink to={`/get-in-touch?lang=${i18n.language}`} className="blueprint-cta primary">
              {t('get_started_button')}
            </NavLink>
            <a href="#custom-dev" className="blueprint-cta ghost">
              {t('hero_secondary_cta')}
            </a>
          </div>
          <div className="blueprint-badges">
            <span>{t('hero_panel_footer_primary')}</span>
            <span>{t('hero_panel_footer_secondary')}</span>
          </div>
        </div>
      </section>

      <section className="blueprint-grid">
        {sections.map((section, idx) => (
          <div className="blueprint-card" id={section.id} key={section.id}>
            <div className="blueprint-card__meta">
              <span className="card-pill">0{idx + 1}</span>
              <span className="card-kicker">{t('blueprint_track')}</span>
            </div>
            <h2>{section.title}</h2>
            <p className="card-subtitle">{section.description}</p>
            <p className="card-detail">{section.detail}</p>
            <div className="card-actions">
              <NavLink to={`/get-in-touch?lang=${i18n.language}`} className="card-link">
                {t('blueprint_cta')}
              </NavLink>
              <a href="#top" className="card-link muted">
                {t('hero_panel_title')}
              </a>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default DeliveryBlueprint;
